import type { QTableProps } from 'quasar';
import { useStrapiGet } from 'src/shared/composables/useStrapiApi';
import { computed } from 'vue';

export type SelectedPlan = {
  planId: number;
  period: 'month' | 'year';
};

export type PlanData = {
  data: string;
  signature: string;
  url: string;
  action: 'subscribe_update' | 'subscribe';
  amount: number;
  currency: 'UAH' | 'USD' | 'EUR';
  description: string;
  order_id: number;
};

export type Plan = {
  id: number;
  documentId: string;
  name: string;
  period: 'day' | 'week' | 'month' | 'year';
  currency: string;
  price: number;
};

export function usePlan() {
  const { data: plans, execute } = useStrapiGet('plans', {
    fields: ['name', 'period', 'price', 'currency'],
  });

  if (!plans.value?.data) void execute();

  const plansOptions = computed<{ label: string; value: number }[]>(() => {
    if (!plans.value?.data) return [];
    return plans.value.data.map((plan: Plan) => ({
      label: `${plan.name} - ${plan.price} ${plan.currency}/${plan.period}`,
      value: plan.id,
    }));
  });

  return {
    plansOptions,
    plans,
    columns,
  };
}

const columns: QTableProps['columns'] = [
  {
    name: 'name',
    label: 'NAME',
    field: 'name',
    align: 'left',
    classes: 'bg-secondary text-dark',
  },
  {
    name: 'period',
    label: 'PERIOD',
    field: 'period',
    align: 'left',
    classes: 'bg-dark text-accent',
  },
  {
    name: 'price',
    label: 'PRICE',
    field: 'price',
    align: 'right',
    classes: 'bg-dark text-accent',
  },
  {
    name: 'currency',
    label: 'CURRENCY',
    field: 'currency',
    align: 'left',
    classes: 'bg-dark text-accent',
  },
];
